import React from 'react';
import { Container } from 'semantic-ui-react';

import AgendarRecuperaciones from './AgendarRecuperaciones';

const Recuperaciones = () => {
    return (
        <Container>
            <AgendarRecuperaciones />
        </Container>
    );
};

export default Recuperaciones;



// WEBPACK FOOTER //
// ./src/modulos/Recuperaciones/index.tsx